import { ArrowLeft, ChevronLeft, ChevronRight, X } from "lucide-react";
import Breadcrumb from "../Breadcrumb";
import Image from "../../ui/Image";

import ConsultingImg from "../../../assets/used-images/training-sec-1.png";
import ConsultingImg2 from "../../../assets/used-images/consulting-img-2.png";
import ConsultingImg1 from "../../../assets/used-images/consulting-img-1.png";

import Eye from "../../../assets/used-images/eye.png";
import Msg from "../../../assets/used-images/message-star.png";

import Consulting1 from "../../../assets/used-icons/consulting-1.svg";
import Consulting2 from "../../../assets/used-icons/consulting-2.svg";
import Consulting3 from "../../../assets/used-icons/consulting-3.svg";
import Consulting4 from "../../../assets/used-icons/consulting-4.svg";
import Consulting5 from "../../../assets/used-icons/consulting-5.svg";
import IvoryGold from "../../../assets/used-icons/IvoryGold.svg";

import Consultant1 from "../../../assets/used-images/consultant-1.png";
import Consultant2 from "../../../assets/used-images/consultant-2.png";
import Consultant3 from "../../../assets/used-images/consultant-3.png";
import Consultant4 from "../../../assets/used-images/consultant-4.png";
import Consultant5 from "../../../assets/used-images/consultant-5.png";
import Consultant6 from "../../../assets/used-images/consultant-6.png";
import Consultant7 from "../../../assets/used-images/consultant-7.png";
import Consultant8 from "../../../assets/used-images/consultant-8.png";
import Consultant9 from "../../../assets/used-images/consultant-9.png";
import Consultant10 from "../../../assets/used-images/consultant-10.png";
import Consultant11 from "../../../assets/used-images/consultant-11.png";
import Consultant12 from "../../../assets/used-images/consultant-12.png";
import Consultant13 from "../../../assets/used-images/consultant-13.png";
import Consultant14 from "../../../assets/used-images/consultant-14.png";
import Consultant15 from "../../../assets/used-images/consultant-15.png";
import Consultant16 from "../../../assets/used-images/consultant-16.png";
import Consultant17 from "../../../assets/used-images/consultant-17.png";
import Consultant18 from "../../../assets/used-images/consultant-18.png";
import Consultant19 from "../../../assets/used-images/consultant-19.png";
import Consultant20 from "../../../assets/used-images/consultant-20.png";
import Consultant21 from "../../../assets/used-images/consultant-21.png";
import Consultant22 from "../../../assets/used-images/consultant-22.png";
import Consultant23 from "../../../assets/used-images/consultant-23.png";
import Consultant24 from "../../../assets/used-images/consultant-24.png";
import Consultant25 from "../../../assets/used-images/consultant-25.png";
import Consultant26 from "../../../assets/used-images/consultant-26.png";
import Consultant27 from "../../../assets/used-images/consultant-27.png";
import Consultant28 from "../../../assets/used-images/consultant-28.png";

import Talent1 from "../../../assets/used-images/talent1.png";
import Talent2 from "../../../assets/used-images/talent2.png";
import Talent3 from "../../../assets/used-images/talent3.png";
import Talent4 from "../../../assets/used-images/talent4.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useState } from "react";
import ServiceApplyBtn from "../../ui/ServiceApplyBtn";
import { FaClipboardList } from 'react-icons/fa'; // For Project Management
import { FaTruck } from 'react-icons/fa'; // For Supply Chain
import { FaUsers } from 'react-icons/fa'; // For Human Resources
import { FaRegSmileBeam } from 'react-icons/fa'; // For Customer Experience
import { FaBullhorn } from 'react-icons/fa'; // For Corporate Communication
const Modal = ({ content, title, setSeenContent }) => {
    return (
        <div className="fixed h-dvh w-full top-0 bg-[#000000c9] z-[999999999] flex justify-center items-center px-28 max-lg:px-4" onClick={() => setSeenContent({
            see: false,
            index: null
        })}>
            <div className="p-4 rounded-xl bg-white z-[9999999999] relative">
                <button className="absolute top-3 right-3 text-primary-tw" onClick={() => setSeenContent({
                    see: false,
                    index: null
                })}>
                    <X size={22} />
                </button>
                <p className="text-secondary-tw text-2xl font-bold mb-2">
                    {title}
                </p>
                <div className="space-y-2 text-right">
                    {
                        content.map((item, i) => (
                            <div key={i}>
                                {++i} - {item}
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}
const Consulting = () => {
    const [active, setActive] = useState(0);
    const [seenContent, setSeenContent] = useState({
        see: false,
        index: null
    });

    const firstSec = [
        {
            icon: Eye,
            title: 'رؤيتنـا',
            desc: 'خلق فرص يومية للمنظمات والمهنيين للتعلم والتطوير الحديث',
        },
        {
            icon: Msg,
            title: 'رسالتنـا',
            desc: 'تقديم حلول تطويرية مبتكرة وذات قيمة ومرنة تتماشى مع الاحتياجات المحددة للمنظمات والمهنيين، من خلال مجموعة أدوات تعلم وتطوير حديثة',
        },
    ];

    const values = [
        {
            icon: Consulting1,
            title: "الكفاءة",
            desc: "حسن استغلال الموارد"
        },
        {
            icon: Consulting2,
            title: "الفعالية",
            desc: "كفاية المعارف والمهارات"
        },
        {
            icon: Consulting3,
            title: "التواصل",
            desc: "تحقيق المعلومات بوضوح وإنجاز"
        },
        {
            icon: Consulting4,
            title: "التقييس",
            desc: "توحيد النظم والمعايير والآليات"
        },
        {
            icon: Consulting5,
            title: "الحداثة",
            desc: "تقديم أدوات تطوير حديثة"
        }
    ];

    const consultingSolutions = [
        {
            title: "إدارة المشاريع",
            icon: <FaClipboardList />,
            desc: "تتميز الشركة بتقديم حلول مبتكرة ومستدامة للتحديات المرتبطة بإدارة المشاريع بالاعتماد على مجموعة من الخبراء المتخصصين والأدوات والتقنيات المتطورة",
            content: [
                "تخطيط المشاريع: تقديم الدعم في تحديد الأهداف والنطاق والموارد المطلوبة للمشاريع ووضع جداول زمنية واضحة لتنفيذ المهام المختلفة.",
                "تنظيم وتنسيق المشاريع: تنظيم المشاريع وفقاً لأفضل الممارسات وضمان تنسيق جميع الجهود والموارد المتوفرة لتحقيق الأهداف المحددة.",
                "مراقبة وتقييم أداء المشاريع: تتبع تقدم المشاريع وتحليل الأداء على أساس دوري، واقتراح التحسينات اللازمة لضمان تحقيق النتائج المستهدفة.",
                "إدارة المخاطر وتحليل المشكلات: تحديد المخاطر المحتملة والعوائق التي قد تواجه المشاريع ووضع خطط للتعامل معها والحد من تأثيرها على تنفيذ المشاريع.",
                "تحسين وتطوير العمليات: استعراض العمليات الحالية وتحديد مجالات التحسين والتطوير لزيادة كفاءة وفعالية إدارة المشاريع.",
                "تدريب وتطوير الكوادر: تقديم برامج تدريبية وورش عمل لتعزيز مهارات الفريق المسؤول عن إدارة المشاريع وتطوير قدراته الإدارية والتنظيمية.",
                "استشارات استراتيجية: تقديم الدعم الاستراتيجي لصناع القرار وتوجيههم نحو تحقيق أهداف المشاريع وتحسين الأداء العام للمؤسسة."
            ]
        },
        {
            title: "سلاسل الإمداد",
            icon: <FaTruck />,
            desc: "تهدف الشركة إلى تحسين أداء سلسلة التوريد للعملاء وتحقيق الكفاءة والمرونة المطلوبة لتلبية متطلبات السوق المتغيرة",
            content: [
                "تخطيط سلسلة التوريد: تقدم الشركة استشارات تتعلق بوضع الخطط الاستراتيجية لإدارة سلسلة التوريد بما يتوافق مع أهداف العملاء واحتياجات السوق. تشمل هذه الخطط تحسين التنسيق بين مختلف مكونات سلسلة التوريد وتحسين عمليات التخزين والنقل والتوزيع.",
                "تحسين كفاءة سلسلة التوريد: تساعد شركة المواهب الاحترافية عملائها في تحسين كفاءة سلسلة التوريد عبر تحليل العمليات الحالية وتحديد مجالات التحسين. يتضمن ذلك تطبيق أفضل الممارسات في الصناعة واستخدام تكنولوجيا المعلومات لتحسين الإدارة والتنسيق.",
                "إدارة المخاطر في سلسلة التوريد: تقدم الشركة خدمات تقييم المخاطر المتعلقة بسلسلة التوريد ووضع استراتيجيات للتعامل معها. تشمل هذه الخدمات تحليل المخاطر المحتملة، مثل تقلبات الطلب والأسعار والنقص في الموارد والكوارث الطبيعية، ووضع خطط استجابة لهذه المخاطر.",
                "التحليل البيئي والاستدامة: تساعد شركة المواهب الاحترافية عملائها في تطوير سلسلة التوريد الصديقة للبيئة والمستدامة. يتضمن ذلك تطبيق ممارسات خضراء وتقليل البصمة الكربونية وضمان الامتثال للوائح البيئية المحلية والدولية.",
                "تطوير الشراكات والتحالفات: تعمل شركة المواهب الاحترافية على تعزيز التعاون بين العملاء وشركاء سلسلة التوريد الآخرين لتحقيق أهداف مشتركة وتوفير فرص لتحسين الأداء وتحقيق النمو."
            ]
        },
        {
            title: "الموارد البشرية",
            icon: <FaUsers />,
            desc: "تقدم الشركة مجموعة متنوعة من خدمات الاستشارات في مجال الموارد البشرية عبر 6 محاور رئيسية",
            content: [
                "استشارات استراتيجية: توفير النصائح والمبادئ التوجيهية لتطبيق استراتيجيات الموارد البشرية الفعالة والمناسبة لكل شركة، وضمان تنسيق وتكامل جميع الأنشطة المتعلقة بالموارد البشرية.",
                "التوظيف والاختيار: مساعدة الشركات في تحديد متطلبات الوظائف وجذب المرشحين المناسبين، بالإضافة إلى تنظيم عمليات الاختيار والتوظيف الفعالة لضمان توافق المهارات مع متطلبات العمل.",
                "تدريب وتطوير الموظفين: تصميم وتنفيذ برامج تدريب وتطوير مخصصة تتناسب مع احتياجات الشركة وتحسين مهارات الموظفين.",
                "تقييم الأداء والتطور المهني: تطوير نظم التقييم الوظيفي وتحسين إجراءات التقييم لتحفيز الموظفين على تحقيق أفضل النتائج وتعزيز تطورهم المهني.",
                "المكافآت والتعويضات: تقديم استشارات حول برامج المكافآت والتعويضات المناسبة والفعالة لجذب والاحتفاظ بالموظفين المتميزين وتعزيز الالتزام والولاء لدى العاملين.",
                "الصحة والسلامة المهنية: تطوير برامج الصحة والسلامة المهنية لضمان بيئة عمل آمنة وصحية للموظفين وتقليل المخاطر المرتبطة بالعمل."
            ]
        },
        {
            title: "تجربة العميل",
            icon: <FaRegSmileBeam />,
            desc: "تهدف الشركة إلى مساعدة الشركات والمؤسسات على تحسين مستوى رضا العملاء والتفاعل معهم من خلال تطوير استراتيجيات فعالة ومبتكرة",
            content: [
                "فهم احتياجات العملاء: تقوم الشركة بتحليل البيانات والاتجاهات لفهم احتياجات وتوقعات العملاء، وذلك من خلال تقييم ردود الفعل والشكاوى وتحليل سلوك العملاء.",
                "تطوير استراتيجية تجربة العملاء: تقوم الشركة بتصميم وتنفيذ استراتيجيات تجربة العملاء المناسبة والمبتكرة وفقاً لاحتياجات وتوقعات العملاء المحددة.",
                "تحسين تفاعل العملاء مع العلامة التجارية: تساعد الشركة في تعزيز تفاعل العملاء مع العلامة التجارية عبر مختلف القنوات، مثل الإعلانات ووسائل التواصل الاجتماعي.",
                "تحسين جودة المنتجات والخدمات: تركز الشركة على تحسين جودة المنتجات والخدمات المقدمة للعملاء من خلال تحديد المشكلات والفرص المحتملة للتطوير والتحسين.",
                "استغلال التقنيات الحديثة: تقوم الشركة بتوظيف أحدث التقنيات وأدوات تحليل البيانات لتعزيز تجارب العملاء وتحسين النتائج التجارية.",
                "قياس وتتبع أداء تجربة العملاء: تضمن الشركة قياس وتتبع أداء استراتيجيات تجربة العملاء بشكل دوري ومنتظم لتحديد مدى فعاليتها وضمان تحسين مستمر.",
                "إعداد دليل تخطيط رحلة العميل في الشركة: تخطيط رحلة العميل من نقطة التفاعل الأولى حتى تفاعله مع المنتج بعد الخدمة."
            ]
        },
        {
            title: "الاتصال المؤسسي",
            icon: <FaBullhorn />,
            desc: "تتمثل مهمة الشركة في مساعدة العملاء على تحسين استراتيجيات الاتصال وتنفيذها بشكل فعال لتعزيز صورتهم وتحقيق أهدافهم التجارية",
            content: [
                "استشارات استراتيجية: تقديم توجيه استراتيجي للعملاء حول كيفية تحسين استراتيجيات الاتصال وتطبيقها بشكل يتماشى مع أهداف المؤسسة.",
                "العلاقات العامة والإعلام: تقديم دعم في مجال العلاقات العامة والإعلام للعملاء، مثل إعداد البيانات الصحفية والمواد الترويجية، وتنظيم المؤتمرات الصحفية والفعاليات الخاصة.",
                "الإعلان والتسويق: تصميم وتنفيذ حملات إعلانية وتسويقية فعالة للعملاء، مع التركيز على تحقيق التأثير المرجو وتعزيز الوعي بالمنتجات والخدمات.",
                "الاتصال الداخلي: تطوير وتنفيذ برامج الاتصال الداخلي لتعزيز التواصل والمشاركة بين الموظفين وتقوية ثقافة المؤسسة.",
                "إدارة الأزمات والمشكلات: مساعدة العملاء في التعامل مع الأزمات والمشكلات المحتملة من خلال تطوير وتنفيذ استراتيجيات فعالة لإدارة الأزمات والتواصل مع الجمهور المستهدف.",
                "التواصل عبر وسائل التواصل الاجتماعي: تطوير وتنفيذ استراتيجيات التواصل عبر وسائل التواصل الاجتماعي لتعزيز الوعي بالعلامة التجارية وتحسين تفاعل الجمهور."
            ]
        }
    ];

    const afterConsultingSolutions = [
        {
            title: 'التعاقب الوظيفي وتصنيف المواهب',
            image: ConsultingImg1,
            details: [
                {
                    title: 'فيما يتعلق بالتعاقب الوظيفي',
                    content: ["تحليل الوظائف الرئيسية وتحديد المواهب الحالية والمستقبلية للمنظمة",
                        "قييم الموظفين المحتملين للتعاقب الوظيفي وإعداد مسارات تطوير واضحة لهم",
                        "قديم برامج تدريب وتطوير قيادية مخصصة لبناء قدرات القادة المستقبليين",
                        "تصميم وتنفيذ خطط التعاقب الوظيفي لضمان تنظيم متناسق واستدامة الأداء"
                    ]
                },
                {
                    title: 'فيما يتعلق بتصنيف المواهب',
                    content: [
                        "إجراء تقييمات موضوعية للموظفين لتحديد قواطع المواهب ومناطق التحسين المحتملة",
                        "تطوير خطط تطوير المواهب المخصصة وفقا لاحتياجات المنظمة واهتمامات الموظفين",
                        "تنظيم ورش عمل وبرامج تدريبية لتطوير مهارات الموظفين وتحسين أدائهم الوظيفي",
                        "تقديم دعم استراتيجي لإدارة المواهب وضمان توافقها مع أهداف المنظمة العامة"
                    ]
                }
            ]
        },
        {
            title: 'تحليل الاحتياجات التدريبية',
            image: ConsultingImg,
            details: [
                {
                    content: [
                        "تقييم الاحتياجات التدريبية: تقوم الشركة بتحديد الفجوات في المعرفة والمهارات الموجودة بين الأفراد والمتطلبات الوظيفية، وتحديد الاحتياجات التدريبية اللازمة لتحسين أداء الموظفين وتحقيق أهداف المؤسسة",
                        "تصميم برامج التدريب: بناءً على تحليل الاحتياجات التدريبية، تقوم الشركة بتصميم برامج تدريبية مخصصة لتلبية الاحتياجات المحددة، بما في ذلك تحديد أهداف التعلم وتطوير المحتوى التدريبي المناسب",
                        "توفير المدربين الخبراء: تضمن الشركة توفير مدربين ذوي خبرة ومهارات عالية في مجالات متنوعة لتنفيذ برامج التدريب وضمان تحقيق أهداف التعلم المنشودة",
                        "تقييم فعالية التدريب: تقيم شركة المواهب الاحترافية فعالية برامج التدريب عن طريق استخدام مجموعة من المعايير والأدوات المتقدمة لقياس التحسين في أداء الموظفين بعد إتمام التدريب",
                        "متابعة وتطوير مستمر: توفر الشركة خدمات متابعة ودعم مستمر للموظفين بعد انتهاء برامج التدريب مع تطوير دورية للمحتوى التدريبي وفقاً لتغيرات متطلبات العمل والصناعة",
                        "تقديم استشارات استراتيجية: تساعد الشركة المؤسسات في وضع استراتيجيات تطوير الموارد البشرية وتحسين الأداء العام عبر تحديد المجالات المحتاجة للتطوير وتوفير حلول تدريبية مبتكرة"
                    ]
                },
            ]
        },
    ];

    const serviceTitles = [
        "الإستراتيجية",
        "التطوير التنظيمي",
        "المراجعة الداخلية",
        "إعداد كراسة الشروط والمواصفات",
        "الصحة والسلامة المهنية",
        "مؤشرات الأداء",
        "إعداد لوحة بيانات تفاعلية"
    ];

    const servicesData = [
        {
            description: "تقدم شركة المواهب الاحترافية في مجال الاستراتيجية خدمات متعددة للمؤسسات والشركات، وتهدف هذه الخدمات إلى تحسين أدائها وتحقيق أهدافها الاستراتيجية. وتشمل هذه الخدمات",
            services: [
                {
                    name: "تطوير استراتيجيات الأعمال",
                    description: "تعمل الشركة على تحديد وضع الشركة الحالي ووضع الأهداف المستقبلية، وتطوير استراتيجيات شاملة تتضمن المبادئ التوجيهية والأهداف الرئيسية لضمان تنفيذ مهام الشركة بنجاح."
                },
                {
                    name: "تحسين وتحليل الأداء",
                    description: "تقدم الشركة تحليل موضوعي لأداء الشركة الحالي وتوصيات مبنية على البيانات لتحسين العمليات وزيادة الكفاءة وتحقيق النمو المستدام."
                },
                {
                    name: "خطط الأعمال والتسويق",
                    description: "تصميم وتنفيذ خطط الأعمال والتسويق التي تضمن تفوق الشركة التنافسي وتعزيز وجودها في السوق مع التركيز على بناء علاقات طويلة الأمد مع العملاء."
                },
                {
                    name: "الشراكات الاستراتيجية ودمج الأعمال",
                    description: "توفير الدعم والمشورة في مجال تكوين الشراكات الاستراتيجية وعمليات دمج الأعمال، وذلك لتوسيع نطاق العمل وتطوير القدرات وزيادة كفاءة التشغيل."
                },
                {
                    name: "الابتكار والتحول الرقمي",
                    description: "تصميم وتنفيذ خطط التحول الرقمي والابتكار في الأعمال، وتساعدها في تحديد وتنفيذ استراتيجيات الابتكار والتحول الرقمي."
                },
                {
                    name: "تقنيات وأدوات حديثة",
                    description: "يعتمد فريق العمل في شركة المواهب الاحترافية على تقنيات حديثة وأدوات مبتكرة لجمع وتحليل المعلومات مما يضمن تقديم نصائح استراتيجية . قائمة على البيانات وتحقيق النتائج المرجوة."
                }
            ]
        },
        {
            description: "تتمثل مهمة الشركة في دعم المؤسسات في تحسين أدائها وزيادة فعاليتها من خلال تنفيذ استراتيجيات تطوير مبتكرة ومستدامة. تتضمن خدماتها في هذا المجال",
            services: [
                {
                    name: "تشخيص التنظيم",
                    description: "تقوم الشركة بتحليل مواطن القوة والضعف في بنية وعمليات المؤسسة، بالإضافة إلى تقييم الثقافة التنظيمية، لتحديد المجالات التي تحتاج إلى تحسين."
                },
                {
                    name: "تصميم الاستراتيجيات",
                    description: "بناءً على التشخيص التنظيمي. تقوم الشركة بوضع استراتيجيات تطوير مخصصة تتناسب مع أهداف ومتطلبات المؤسسة وتعزز قدراتها التنافسية."
                },
                {
                    name: "تنفيذ المبادرات",
                    description: "تدعم الشركة المؤسسات في تنفيذ المبادرات الهادفة إلى تحسين الأداء والتحول التنظيمي، مثل تطوير قدرات القيادة، تحسين الاتصال الداخلي، وتعزيز الانخراط الموظفين."
                },
                {
                    name: "تقييم ومراقبة",
                    description: "تقوم الشركة بمراقبة تطبيق استراتيجيات التطوير التنظيمي وتقييم نجاحها عن طريق استخدام مجموعة من المؤشرات والأدوات القياسية لضمان تحقيق النتائج المرجوة."
                },
                {
                    name: "تحسين مستمر",
                    description: "تعمل الشركة على تطوير حلول مبتكرة ومستدامة لتحسين الأداء والنمو المستمر للمؤسسات، مع التركيز على تحسين جودة الخدمات وزيادة رضا العملاء."
                },
                {
                    name: "تدريب وتطوير الموارد البشرية",
                    description: "توفر شركة برامج تدريبية وورش عمل متخصصة في مجال التطوير التنظيمي لتعزيز مهارات القيادة والإدارة بين الموظفين وتمكينهم من تحقيق التحول التنظيمي المطلوب."
                }
            ]
        },
        {
            description: "تهدف الشركة في خدمات المراجعة الداخلية إلى تعزيز جودة وفعالية عمليات المراجعة الداخلية للمؤسسات من خلال توفير خدمات استشارية مبتكرة ومتكاملة تتناسب مع احتياجات العملاء. تتميز شركة المواهب الاحترافية بتوفير الخدمات التالية",
            services: [
                {
                    name: "تحليل الوضع الحالي",
                    description: "حيث تقوم الشركة بتحليل الوضع الحالي للمؤسسة من خلال تقييم العمليات والنظم الداخلية وتحديد المشاكل والتحديات التي تواجه المؤسسة في هذا المجال."
                },
                {
                    name: "تصميم خطة المراجعة الداخلية",
                    description: "حيث تقوم الشركة بتصميم خطة لعملية المراجعة الداخلية، وتشمل هذه الخطة تحديد الأهداف والمعايير التي يتم التحقق منها خلال عملية المراجعة."
                },
                {
                    name: "تنفيذ عملية المراجعة الداخلية",
                    description: "حيث يتم تنفيذ خطة المراجعة الداخلية وتقييم الأنشطة والعمليات والنظم الداخلية للمؤسسة."
                },
                {
                    name: "تقييم ممارسات وبنية المراجعة الداخلية",
                    description: "حيث تقوم الشركة بإعداد تقارير تفصيلية تحتوى على النتائج والملاحظات والتوصيلات الازمة لتحسين الأداء والعمليات الداخلية للمؤسسة."
                },
                {
                    name: "تطوير وتحديث سياسات وإجراءات المراجعة الداخلية",
                    description: "تساعد الشركة في وضع سياسات وإجراءات جديدة أو تحديث السياسات الحالية للمراجعة الداخلية لضمان تطبيق أفضل الممارسات والمعايير الدولية."
                },
                {
                    name: "توفير التدريب والتطوير للموظفين",
                    description: "تقدم الشركة برامج تدريبية وورش عمل مصممة لتعزيز مهارات الموظفين فى مجال المراجعة الداخلية وتحسين كفاءتهم."
                },
                {
                    name: "تنفيذ مراجعات داخلية مستقلة",
                    description: "تقدم الشركة خدمات المراجعة الداخلية الشاملة والمستقلة لتحديد المخاطر وتقييم فعالية الرقابة الداخلية وتحسين الأداء."
                },
                {
                    name: "استشارات في مجال تطبيق تقنيات المراجعة الداخلية",
                    description: "تقدم الشركة دعما تقنيا واستشارات لتطبيق أحدث تقنيات المراجعة الداخلية وتحسين جودة عمليات المراجعة."
                }
            ]
        },
        {
            description: "تشمل خدمات الشركه فى هذا المجال ما يلى",
            services: [
                {
                    name: "كراسة الشروط",
                    description: "تعمل الشركة على تطوير كراسة الشروط الفنية والإدارية للمشاريع، والتي تحدد متطلبات المشروع والمعايير التي يجب على المقاولين الالتزام بها. يعتبر هذا الجزء أساسيًا من عملية طلب العروض أو المناقصات."
                },
                {
                    name: "المواصفات",
                    description: "تقدم الشركة خدمات إعداد ومراجعة المواصفات الفنية والجودة للمشاريع، مع التأكيد على توافقها مع المعايير المحلية والدولية المعمول بها في الصناعة."
                }
            ]
        },
        {
            description: "تركز الشركة على تحسين بيئة العمل وحماية الموظفين من المخاطر المحتملة والحوادث المهنية. تشمل خدماتها في هذا المجال",
            services: [
                {
                    name: "تقييم المخاطر",
                    description: "تقوم الشركة بإجراء تقييمات شاملة للمخاطر في مكان العمل وتحديد العوامل المحتملة التي قد تؤثر على سلامة العاملين والعمليات."
                },
                {
                    name: "تطوير وتنفيذ سياسات السلامة",
                    description: "تعمل الشركة على تصميم وتطبيق سياسات السلامة المهنية المناسبة والإجراءات التشغيلية المعيارية للحد من المخاطر."
                },
                {
                    name: "تدريب وتوعية الموظفين",
                    description: "تقدم الشركة برامج تدريبية على السلامة وتركز على زيادة الوعي حول الممارسات الآمنة والمسؤوليات الفردية،والجماعية للحفاظ على سلامة الجميع."
                },
                {
                    name: "التحقيق في الحوادث",
                    description: "في حالة حدوث حوادث مهنية، تقوم شركة ايفوري بالتحقيق في الأسباب المحتملة واقتراح تدابير ملائمة لمنع تكرار مثل هذه الحوادث فى المستقبل."
                },
                {
                    name: "التفتيش والمراجعة",
                    description: "تقوم الشركة بإجراء تفتيش دوري على مرافق العمل للتحقق من تنفيذ السياسات والإجراءات الخاصة بالسلامة المهنية وتحديد أي نقصقد يتطلب تدخلا."
                },
                {
                    name: "الامتثال للتشريعات والمعايير",
                    description: "تتضمن الشركة امتثال المنظمات للقوانين واللوائح المحلية والدولية المتعلقة بالأمن والسلامة المهنية وتوفير التوجية والدعم الازم لتحقيق هذا الامتثال."
                }
            ]
        },
        {
            description: "تتمثل مهمة الشركة في مساعدة عملائها على تحقيق أهدافهم وتحسين كفاءتهم من خلال تحديد المؤشرات الرئيسية للأداء KPIs ووضع استراتيجيات لتعزيز الأداء. في سياق عملها، قدمت شركة المواهب الاحترافية استشارات في مجال مؤشرات الأداء لعدة شركات ومؤسسات من مختلف القطاعات",
            services: [
                {
                    name: "تحليل الوضع الراهن",
                    description: "تبدأ الشركة بإجراء تحليل شامل لوضع الأداء الحالي للشركة العميلة، وتقييم قواطع الأداء ومعرفة المجالات التي تحتاج إلى تحسين."
                },
                {
                    name: "تحديد المؤشرات الرئيسية للأداء KPIs",
                    description: "تعمل الشركة مع العميل على تحديد مجموعة من المؤشرات الرئيسية للأداء التي تعكس أهداف واستراتيجية الشركة."
                },
                {
                    name: "وضع خطة تحسين",
                    description: "بناءً على تحليل الوضع الراهن والمؤشرات المحددة، تقوم الشركة بوضع خطة تفصيلية لتحسين الأداء في المجالات الضعيفة وتعزيز النقاط القوية."
                },
                {
                    name: "تنفيذ ومتابعة",
                    description: "تقدم الشركة دعما لعملائها في تنفيذ خطط التحسين، وتتابع التقدم المحرز بشكل دوري وتقديم توجيهات لضمان تحقيق الأهداف المرجوة."
                },
                {
                    name: "تقييم ومراجعة",
                    description: "بعد فترة من التنفيذ، تقوم الشركة بتقييم نتائج تطبيق الخطط ومراجعة المؤشرات والاستراتيجيات للتأكد من تحقيق تحسين مستدام في الأداء."
                }
            ]
        },
        {
            description: "تمتاز الشركة بفريق عمل محترف وذو خبرة عالية في تصميم وبناء الحلول المتكاملة لقواعد البيانات ولوحات المعلومات بالإضافة إلى تقديم الدورات التدريبية والورش العملية لتطوير مهارات العاملين في هذا المجال",
            services: [
                {
                    name: "تصميم وإنشاء قواعد بيانات مخصصة",
                    description: "تقديم استشارات في مجال تصميم قواعد البيانات المناسبة لاحتياجات العملاء وبناء قواعد بيانات متكاملة تعزز كفاءة عمليات جمع وتخزين واسترجاع البيانات."
                },
                {
                    name: "تطوير قواعد بيانات موجودة",
                    description: "تحسين أداء قواعد البيانات الحالية وتوسيع قدراتها لمواكبة التطور والنمو في الأعمال."
                },
                {
                    name: "إنشاء لوحات المعلومات",
                    description: "تصميم وتطوير لوحات معلومات تفاعلية ومرئية تسهل عملية استخلاص الأفكار والاتجاهات من البيانات وتوفير التقارير اللازمة لاتخاذ القرارات المستنيرة."
                },
                {
                    name: "تدريب وتطوير الموارد البشرية",
                    description: "تقديم دورات تدريبية وورش عمل متخصصة في مجال إدارة قواعد البيانات و لوحات المعلومات لتعزيز مهارات العاملين وتأهيلهم للتعامل مع تقنيات البيانات المتقدمة."
                }
            ]
        }
    ];

    const consultants = [
        {
            name: "أ.موسى قشيش",
            specialization: "الإستراتيجية",
            description: "مستشار متخصص في تخطيط وأداء ومؤشرات ومشاريع وجودة حاصل على شهادة PMP وذو خبرة في التدريب مع وزارات وهيئات منوعة.",
            image: Consultant1
        },
        {
            name: "أ.بشار عميش",
            specialization: "سلاسل الامداد والمشتريات",
            description: "مستشار متخصص في تحسين وتطوير سلاسل الإمداد والتوريد. بالإضافة إلى إدارة المخزون وتقليل التكاليف يعمل على تعزيز كفاءة وأداء المؤسسات من خلال استراتيجيات فعالة.",
            image: Consultant2
        },
        {
            name: "أ. محمود الصالح",
            specialization: "إدارة المشاريع",
            description: "رئيس تنفيذي من الدرجة الأولى مع الخبرة الكبيرة في إنشاء وإدارة المنظمات والفروع والمكاتب ، وصياغة المشاريع والمبادرات لديه خبرة واسعة في إدارة الشركات والمشاريع الكبرى و تحليل الاحتياجات التدريبية.",
            image: Consultant3
        },
        {
            name: "د.ماجد العمودي",
            specialization: "الموارد البشرية",
            description: "مستشار خبير في إدارة الموارد البشرية وتوجيه الفرق العاملة ضمن المؤسسات الكبيرة مع التركيز على تحسين الأداء وتعزيز التعاون بين الأفراد.",
            image: Consultant4
        },
        {
            name: "أ.سعيد الجمل",
            specialization: "المراجعة الداخلية",
            description: "مستشار مالي و مراجع داخلي متميز متخصص في تحليل البيانات المالية وتحسين العمليات المالية يساعد المؤسسات على تحقيق كفاءة مالية عالية وضمان الالتزام بالإجراءات والسياسات المالية.",
            image: Consultant5
        },
        {
            name: "د.محمد السيد",
            specialization: "المراجعة الداخلية",
            description: "مستشار محترف في مجال المحاسبة والمراجعة المالية. مدرب معتمد لدى جامعة الإسكندرية، يعمل على تعزيز المهارات المالية والمحاسبة الأفراد والمؤسسات.",
            image: Consultant6
        },
        {
            name: "أ.احمد الدوسري",
            specialization: "السلامة والصحة والمهنية",
            description: "مستشار إدارة السلامة والصحة المهنية وتطبيق معايير السلامة والصحة المهنية في المؤسسات.",
            image: Consultant7
        },
        {
            name: "أ.مسفر العرجاني",
            specialization: "إدارة المشاريع",
            description: "مستشار متخصص في المنظمات غير الربحية، والمشاريع التنموية والاجتماعية وقياس الأثر الاجتماعي والمنهجيات العلمية.",
            image: Consultant8
        },
        {
            name: "أ.عبدالرحمن شيبه",
            specialization: "الاتصال المؤسسة",
            description: "مستشار في العلاقات العامة وإدارة المحتوى الإعلامي مدرب في تحديد جمهور المنظمات واستخدام التحليل الرقمي.",
            image: Consultant9
        },
        {
            name: "وائل عثمان",
            specialization: "سلاسل الإمداد والمشتريات",
            description: "مستشار سلاسل توريد خبرة 15 عاما ماجستير إدارة النقل عمل بمشاريع الفنادق",
            image: Consultant10
        },
        {
            name: "أ.سامي سعدي عواد",
            specialization: "إدارة المشاريع",
            description: "مستشار هندسي وإدارة مشاريع بجامعة نايف العربية للعلوم الأمنية، كما يعمل مستشاراً تدريبيا في بنك الرياضي مساهما في تطوير المهارات الهندسية والإدارية في مجالات عمله",
            image: Consultant11
        },
        {
            name: "أ.علوي آل ماجد",
            specialization: "السلامة والصحة المهنية",
            description: "مستشار في الصحة والسلامة وهندسة العوامل البشرية ذو خبرة عالية في مجال الصحة والسلامة المهنية وتحسين بيئة العمل.",
            image: Consultant12
        },
        {
            name: "د.عبدالهادي القحطاني",
            specialization: "الاتصال المؤسسي",
            description: "مستشار فى الاعلام و الاتصال الإستراتيجي خبرة 25 عاما فى المناصب الإدارية و القيادية.",
            image: Consultant13
        },
        {
            name: "احمد الحضر",
            specialization: "الموارد البشرية",
            description: "مستشار استراتيجي للمنشآت. متخصص في مجال ريادة الأعمال وإعداد دراسات الجدوى الاقتصادية والفنية.",
            image: Consultant14
        },
        {
            name: "د. تامر محمود أحمد",
            specialization: "المراجعة الداخلية",
            description: "مستشار متمرس في مجال المراجعة الداخلية، يعمل على تحسين وتقيم الإجراءات والسياسات المالية والإدارية داخل المؤسسات.",
            image: Consultant15
        },
        {
            name: "أ.محمد حسين إمام",
            specialization: "إدارة مشاريع",
            description: "مستشار متخصص في إدارة المشروعات الاحترافية وتطبيق وتحسين أنظمة الأيزو يساعد المؤسسات على تطوير استراتيجيات فغالة وتحقيق معاير جودة عالية.",
            image: Consultant16
        },
        {
            name: "أ.محمد السليم",
            specialization: "إعداد كراسة الشروط والمواصفات",
            description: "مستشار ومحامي ومدرب ومؤلف متميز يمتلك خبرة واسعة في مجال الفنون الحكومي والتدريب والاستشارات كما شارك فى العديد من اللجان الحكومية.",
            image: Consultant17
        },
        {
            name: "أ.محسن التاجر",
            specialization: "الصحة السلامة المهنية",
            description: "مستشار صحة وسلامة معتمد عضو سابق في مجلس إدارة جمعية الصحة والسلامة وشغل مناصب إدارة.",
            image: Consultant18
        },
        {
            name: "أ.علي القحطاني",
            specialization: "سلاسل الامداد والمشتريات",
            description: "مستشار سلاسل الإمداد ومدرب معتمد في المجال باللغتين العربية والإنجليزية، قدم العديد من الدورات الحضورية عبر الإنترنت.",
            image: Consultant19
        },
        {
            name: "أ.محمد علي الأديمي",
            specialization: "التسويق وتجربة العميل",
            description: "مستشار تسويق وإدارة مواهب بخبرة تمتد الأكثر من 19 عاما. مؤلف ومدرب وقدم دورات تدريبية لالاف الأشخاص.",
            image: Consultant20
        },
        {
            name: "أ.عطية الزهراني",
            specialization: "السلامة والصحة المهنية.",
            description: "مستشار متخصص في مجال السلامة والصحة المهنية يركز على تدريب العاملين وتطوير مهاراتهم لضمان بيئة عمل أمنة وصحية.",
            image: Consultant21
        },
        {
            name: "أ.محمد الزبيدي",
            specialization: "تحليل الاحتياجات التدريبية",
            description: "مستشار متخصص في تطوير المنظمات والأفراد يقدم التوجيه والاستشارات لتعزيز الأداء والتطوير المهني والشخصي.",
            image: Consultant22
        },
        {
            name: "د.عبدالله الضابط",
            specialization: "الموارد بشرية",
            description: "مستشار متميز في مجال الموارد البشرية، ذو خبرة كبيرة بتقديم التوجيه والاستشارات الفعالة لتطوير وتحسين إدارة الموارد البشرية داخل المؤسسات.",
            image: Consultant23
        },
        {
            name: "أ.أحمد شحروج",
            specialization: "الموارد البشرية والابتكار المؤسسي",
            description: "مستشار متخصص في تنمية الموارد البشرية والابتكار المؤسسي ومدرب معتمد من قبل مؤسسات دولية مرموقة ومعترف بها.",
            image: Consultant24
        },
        {
            name: "أ.عبدالرحمن الدخيل",
            specialization: "إعداد لوحة بيانان تفاعلية",
            description: "مستشار متخصص في تحليل البيانات بخبرة واسعة في استخدام برامج مثل Power B لتحويل البيانات الخام إلى معلومات قيمة يمتاز بقدرته على التعامل مع تحديات التخطيط الاستراتيجي ووضع مؤشرات الأداء المناسبة لقياس نجاج المنظمات.",
            image: Consultant25
        },
        {
            name: "أ.غانم العنزي",
            specialization: "الموارد البشرية وتحليل الاحتياجات التدريبية",
            description: "مستشار تدريب وإدارة وموارد بشرية يوفر النصح والإرشاد والتدريب المتخصص.",
            image: Consultant26
        },
        {
            name: "أ.جميل خليفة",
            specialization: "المراجعة الداخلية",
            description: "مستشار ذو خبرة واسعة في الجوانب المهنية والتطبيقية والإدارية، يتمتع بالقدرة على التعامل من قطاعات متنوعة و متعدده.",
            image: Consultant27
        },
        {
            name: "أ.محمد الشمري",
            specialization: "الإستراتيجية",
            description: "مستشار استراتيجي ومدرب متخصص في تطوير الأعمال. لديه خبرة في المشاركة بفرق العمل الاستشارية المتنوعة وحاصل على عدة شهادات مهنية.",
            image: Consultant28
        }
    ];

    const projects = [
        {
            title: "تأهيل وإعداد الموظفين الجدد",
            description: "مستشفى دله"
        },
        {
            title: "مشروع تحليل الاحتياجات التدريبية",
            description: "مكتب تحقيق الرؤية في وزارة الصحة"
        },
        {
            title: "مشروع استشارات وتدريب في المراجعة الداخلية",
            description: "المديرية العامة للجوازات"
        },
        {
            title: "التعاقب الوظيفي",
            description: "ملاذ للتأمين التعاوني"
        },
        {
            title: "مشروع تحليل الاحتياجات التدريبية",
            description: "وزارة الموارد البشرية والتنمية الاجتماعية"
        },
        {
            title: "مشروع تحليل الاحتياجات التدريبية",
            description: "مستشفى الملك خالد التخصصي للعيون"
        },
        {
            title: "الاتصال المؤسسي",
            description: "مؤسسة الملك خالد الخيرية"
        },
        {
            title: "تنمية الموارد المالية",
            description: "مؤسسة الملك خالد الخيرية"
        }
    ];

    const whyProffessionalTalents = [
        {
            title: "فريق استشاري مؤهل وذو خبرة عالمية",
            description: "تتميز الشركة بوجود فريق عمل مؤهل وذو خبرة عالية في مجال الاستشارات، حيث يتمتع أعضاء الفريق بالمعرفة والخبرة اللازمة لتقديم النصائح والاستشارات المفيدة للشركات والمؤسسات",
            image: Talent1,
        },
        {
            title: "التركيز على الجودة والاستدامة",
            description: "تضع الشركة التركيز على الجودة والاستدامة في كل جوانب عملها وخدماتها، وتعمل على تحقيق أفضل النتائج الممكنة بطريقة مستدامة وفعالة",
            image: Talent2,
        },
        {
            title: "تنوع الخدمات",
            description: "تقدم الشركة خدمات استشارية متنوعة في مجالات عدة مثل إدارة المشاريع وسلاسل الإمداد ومكافحة الرشوة والمخاطر والنظم القانونية، مما يسمح للعملاء بالحصول على النصائح والاستشارات المتخصصة في مجالات متعددة",
            image: Talent3,
        },
        {
            title: "استخدام أحدث التقنيات والأدوات المتخصصة",
            description: "تستخدم الشركة أحدث التقنيات والأدوات المتخصصة في مجال الاستشارات، وتحرص على البحث المستمر عن أفضل الحلول والتقنيات الجديدة لتحقيق أفضل النتائج للعملاء",
            image: Talent4,
        }
    ];

    return (
        <>
            <Breadcrumb pages={["الخدمات", "الخدمات الاستشارية"]} />
            <main className="container my-8">
                <section className="relative border rounded-lg text-right px-3 py-10">
                    <div className="flex justify-center items-center">
                        <div className="absolute -top-4 bg-primary-tw text-white px-4 !py-3 rounded-xl">
                            استفد من خبرتنا في تقييم المواهب لتعزيز مسيرتك نحو الإنجازات الاستثنائية
                        </div>
                    </div>
                    <p className="services-header  after:w-24">
                        عن المواهب الاحترافية
                    </p>
                    <article>
                        هي شركة ذات رؤية إقليمية في مجال تقديم الاستشارات فى السعودية والشرق الأوسط متخصصة في تحقيق التميز التنظيمي للمؤسسات والشركات بإلتزامنا نحو التطور والابتكار.
                        نركز على تقديم حلول استشارية مصممة خصيصًا لتلبية احتياجات عملائنا، معتمدين على أساليب عالمية رائدة في تطوير الموارد البشرية، تعزيز القدرات، وصقل المواهب ، نهدف إلى إرساء أسس متينة للنمو المستدام وتحقيق أعلى مستويات الأداء
                    </article>
                </section>

                <section className="grid grid-cols-[29%_69%] gap-5 !px-4 max-lg:grid-cols-1 my-8">
                    <div className="relative">
                        <div className="w-full h-full border rounded-lg z-10 absolute -top-2 -right-4"></div>
                        <Image
                            src={ConsultingImg}
                            alt={'consulting-image'}
                            className={'rounded-lg w-full h-full z-50 relative top-3 -left-[6px]'}
                        />
                    </div>
                    <div className="space-y-6">
                        {
                            firstSec.map((sec, i) => (
                                <div className="flex items-start gap-2 text-right" key={i}>
                                    <div className="size-14 border rounded-full">
                                        <div className="size-14 flex justify-center items-center">
                                            <img src={sec.icon} alt={sec.title} className="w-8" />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-secondary-tw">
                                            {sec.title}
                                        </p>
                                        <p className="text-semi-gray w-[36rem] max-lg:w-auto">
                                            {sec.desc}
                                        </p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </section>

                {/* قيمنا */}
                <section className="my-8">
                    <div className="flex justify-center">
                        <p className="services-header flex justify-center items-center">
                            قيمنا
                        </p>
                    </div>
                    <div className="lg:flex lg:justify-center lg:gap-10 scrolling max-lg:gap-3 py-12">
                        {
                            values.map((val, i) => (
                                <div key={i} className="relative rounded-lg bg-secondary-tw text-white flex flex-col items-center py-4 px-8">
                                    <div className="max-lg:w-40"></div>
                                    <div className="absolute -top-10 z-30 bg-secondary-tw size-16 rounded-full border flex justify-center items-center">
                                        <img src={val.icon} alt={val.title} className="w-7" />
                                    </div>
                                    <p className="text-lg">
                                        {val.title}
                                    </p>
                                    <p className="text-sm">
                                        {val.desc}
                                    </p>
                                </div>
                            ))
                        }
                    </div>
                </section>
            </main>

            {/* الخدمات الإستشارية */}
            {/* <section className="flex flex-col items-center justify-center rounded-lg bg-light-gray py-4 border mt-8">
                <p className="services-header flex justify-center items-center after:w-32">
                    الخدمات الإستشارية
                </p>
                <article className="px-28 text-lg max-md:px-4">
                    الأصول الأساسية للشركات التي تقدم استشارات هي فريقها الإستشاري المحترف وقاعدة المهارات التخصصية التي توفرها لتضيف أحدث الممارسات التي تلبي احتياجات العملاء، من الناحية الاستراتيجية، تمتلك شركة المواهب الإحترافية فريق استشاري متخصص ذو خبرة عريقة ولديها سابقة أعمال مع كبرى الشركات والمنظمات والمؤسسات الحكومية، مما يتيح لها المشاركة في تزويد العملاء الأدوات والمهارات والممارسات الحديثة والمتخصصة لتلبي الاحتياجات الملحة للعملاء
                </article>
            </section> */}

            {/* الحلول الإستشارية */}
            <section className="relative pb-20 " style={{ backgroundImage: `url(${ConsultingImg2})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                <div className="absolute z-10 w-full h-full bg-gradient-to-t from-[rgba(106,47,56,0.95)] to-[rgba(84,18,37,0.95)]"></div>
                <div className="container">
                    <div className="relative z-20 text-white space-y-9">
                        <div className="flex flex-col items-center gap-2 text-white">
                            <p className="services-header flex justify-center">
                                الحلول الإستشارية
                            </p>
                            <p className="text-white w-8/12 max-md:w-full">
                                مع أكثر من 10 سنوات من الخبرة في تقديم الاستشارات التطويرية للعملاء في المملكة العربية السعودية والوطن العربي، تسعى الشركة إلى تزويد العملاء بالأدوات التطويرية في عدة مجالات تساهم في بناء القدرات التنظيمية واكتساب العملاء وتحسين العمليات واختراق الأسواق وتشمل مجالات الاستشارات
                            </p>
                        </div>
                        <div className="scrolling max-lg:px-4 !gap-4 lg:grid lg:grid-cols-5 lg:gap-6 ">
                            {
                                consultingSolutions?.map((item, i) => (
                                    <div key={i} className="bg-[#ffffffc9] grid gap-6 justify-between items-start p-2 py-4 w-full rounded-xl max-lg:min-w-96">
                                       <div className="flex justify-center items-center" 
                                       style={{
                                        fontSize: '1.5rem',
                                        background:'#6a2f38',
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        margin: '10px auto',
                                       }}>{item.icon}
                                        </div>
                                        <p className="text-[#333] text-xl font-semibold">
                                            {item.title}
                                        </p>
                                        <article className="text-right text-common-text text-lg h-44">
                                            {item.desc}
                                        </article>
                                        <button
                                            onClick={() => setSeenContent({
                                                see: true,
                                                index: i
                                            })}
                                            className="flex items-center font-semibold text-[#6a2f38] justify-center gap-2 ">
                                            <span>
                                                عرض المزيد
                                            </span>
                                            <span>
                                                <ArrowLeft size={18} />
                                            </span>
                                        </button>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
            {seenContent.see && seenContent.index !== null &&
                <Modal setSeenContent={setSeenContent}
                    see={seenContent.see}
                    title={consultingSolutions[seenContent.index].title}
                    content={consultingSolutions[seenContent.index].content}
                />}
            {/* التعاقب الوظيفي وتصنيف المواهب */}
            <section className="mt-10 container">
                {
                    afterConsultingSolutions.map((section, i) => (
                        <div key={i} className={`grid grid-cols-2 gap-10 px-4 py-2 max-lg:grid-cols-1 `}>
                            <div className={`${(i + 1) % 2 === 0 ? 'order-2' : 'order-1'}`}>
                                <p className="services-header after:w-24">
                                    {section.title}
                                </p>
                                <div className="space-y-4">
                                    {
                                        section.details.map((detail, iD) => (
                                            <div key={iD} className="border rounded-lg p-3 text-right space-y-2">
                                                <p className="text-secondary-tw text-lg">
                                                    {detail?.title}
                                                </p>
                                                <div>
                                                    {detail.content.map((cont, iC) => (
                                                        <div
                                                            className="flex items-start gap-2"
                                                            key={iC}>
                                                            <span>
                                                                <img src={IvoryGold} alt="ivory-list" className="w-4 mt-2" />
                                                            </span>
                                                            <p className="text-common-text">
                                                                {cont}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className={`w-full h-full py-2 px-0 max-lg:p-0 relative ${(i + 1) % 2 === 0 ? 'order-1' : 'order-2'} `}>
                                <Image src={section.image} alt={section.title} className="rounded-lg w-full h-full object-cover" />
                            </div>
                        </div>
                    ))
                }
            </section>

            {/* الاستراتجيه و التطوير التنظيمي و ..... */}
            <div className="container">
                <section className="grid grid-cols-[22%_76%]  max-lg:grid-cols-1 gap-4 items-start py-7 max-lg:p-1 my-12">
                    <div className="scrolling lg:grid gap-2 rounded-lg p-3">
                        {
                            serviceTitles.map((title, i) => (
                                <button key={i} className={`${active === i ? 'bg-primary-tw text-white' : 'bg-light-gray text-common-text'} rounded-md text-nowrap px-4 py-2`}
                                    onClick={() => setActive(i)}
                                >
                                    {title}
                                </button>
                            ))
                        }
                    </div>
                    <div className="p-3">
                        <div>
                            <div className="bg-secondary-tw rounded-md p-3 text-white">
                                <p className="text-lg">
                                    {servicesData[active].description}
                                </p>
                            </div>
                        </div>
                        <div className="scrolling justify-between gap-3 my-3 px-1">
                            {
                                servicesData[active].services.map((serv, i) => (
                                    <div key={i} className="border rounded-md p-3 w-80 space-y-2">
                                        <p className="text-secondary-tw text-lg font-bold">
                                            {serv.name}
                                        </p>
                                        <p className="text-right text-common-text w-[17rem]">
                                            {serv.description}
                                        </p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </section>
            </div>
            {/* الفريق الاستشارى */}
            <section className="bg-[#E5E5E526] ">
                <div className="container">
                    <div className="flex justify-center">
                        <p className="services-header flex justify-center after:w-32 after:-bottom-3">
                            الفريق الاستشارى
                        </p>
                    </div>

                    <section className="flex items-center justify-center gap-4 max-lg:gap-2">
                        <button className="prev-consult flex justify-center items-center p-1 rounded-md border-2 border-secondary-tw text-secondary-tw" title="Next">
                            <ChevronRight size={20} />
                        </button>
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            slidesPerView={1}
                            spaceBetween={45}
                            navigation={{
                                nextEl: '.next-consult',
                                prevEl: '.prev-consult'
                            }}
                            loop={true}
                            autoplay={{ delay: 4000, disableOnInteraction: false }}
                            breakpoints={{
                                300: { slidesPerView: 1 },
                                776: { slidesPerView: 2 },
                                1024: { slidesPerView: 3 },
                                1600: { slidesPerView: 4 },
                            }}
                            className="p-3"
                        >
                            {
                                consultants.map((consultant, i) => (
                                    <SwiperSlide key={i} className="relative rounded-tl-3xl rounded-lg border bg-white p-3 my-4 text-right !h-64">
                                        <div className="flex flex-col items-start h-full">
                                            <div className="absolute -top-8 -right-7 rounded-lg size-24">
                                                <img src={consultant.image} alt={consultant.name} className="w-full h-full object-center rounded-lg" />
                                            </div>
                                            <div className="pr-16 mb-6">
                                                <p className="text-lg">
                                                    {consultant.name}
                                                </p>
                                                <p className="text-sm text-secondary-tw">
                                                    {consultant.specialization}
                                                </p>
                                            </div>
                                            <div>
                                                <p>
                                                    {consultant.description}
                                                </p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                        <button className="next-consult flex justify-center items-center p-1 rounded-md border-2 border-secondary-tw text-secondary-tw" title="Previous">
                            <ChevronLeft size={20} />
                        </button>
                    </section>
                </div>
            </section>

            {/* الاعمال الإستشارية */}
            <section className="py-12">
                <div className="flex justify-center my-2">
                    <p className="services-header flex justify-center after:w-24">
                        الأعمال الإستشارية
                    </p>
                </div>
                <div className="container">
                    <section className="grid grid-cols-3 gap-4 justify-center  max-lg:px-6 max-2xl:grid-cols-2 max-lg:grid-cols-1">
                        {
                            projects.map((project, i) => (
                                <div key={i} className="border space-y-3 rounded-md px-4 py-4 text-right">
                                    <div className="flex items-center gap-2 text-lg">
                                        <span>
                                            <img src={IvoryGold} alt="ivory-list" />
                                        </span>
                                        <p>
                                            {project.title}
                                        </p>
                                    </div>
                                    <p className=" text-gray-500 px-4">
                                        {project.description}
                                    </p>
                                </div>
                            ))
                        }
                    </section>
                </div>
            </section>

            {/* لماذا المواهب الاحترافية */}
            <section className="container">
                <div className="flex justify-center my-3">
                    <p className="services-header flex justify-center after:w-24">
                        لماذا المواهب الاحترافية
                    </p>
                </div>
                <section className="grid grid-cols-2 gap-8 py-6 px-2 max-2xl:grid-cols-1">
                    {
                        whyProffessionalTalents.map((talent, i) => (
                            <div key={i} className={`grid grid-cols-4 gap-4`}>
                                <div className={`w-full h-full rounded-lg col-span-1 max-lg:col-span-2 ${(i === 0 || i === 1) ? 'order-last' : ''} relative`}>
                                    <Image
                                        src={talent.image}
                                        alt={talent.title}
                                        className={'w-full h-full object-cover rounded-lg object-center'}
                                    />
                                </div>
                                <div className="border rounded-lg p-3 space-y-2 text-right col-span-3 max-lg:col-span-2">
                                    <p className="text-secondary-tw">
                                        {talent.title}
                                    </p>
                                    <article className="text-common-text">
                                        {talent.description}
                                    </article>
                                </div>
                            </div>
                        ))
                    }
                </section>
            </section>

            <ServiceApplyBtn serviceId={8} serviceName={'الخدمات الاستشارية'}/>
        </>
    )
};

export default Consulting;